
import { Menu } from "lucide-react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { NavigationLink } from "./NavigationLink";
import { mainLinks, toolLinks, profileLinks } from "./NavigationConfig";
import { LogoutButton } from "./LogoutButton";

export const MobileNavigation = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b z-40 shadow-sm">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-10 w-10 absolute top-1/2 left-6 -translate-y-1/2 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
          >
            <Menu className="!w-6 !h-6" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-64 pt-16">
          <div className="flex flex-col h-full">
            <div className="flex-1 flex flex-col space-y-1">
              {mainLinks.map((link) => (
                <NavigationLink
                  key={link.path}
                  {...link}
                  isActive={isActive(link.path)}
                  onClick={() => setIsOpen(false)}
                  className="p-4 rounded-lg"
                />
              ))}
              
              <div className="mt-4 mb-2">
                <div className="flex items-center px-4 py-2">
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Herramientas</span>
                </div>
                
                {toolLinks.map((link) => (
                  <NavigationLink
                    key={link.path}
                    {...link}
                    isActive={isActive(link.path)}
                    onClick={() => setIsOpen(false)}
                    className="p-4 rounded-lg"
                  />
                ))}
              </div>
              
              {profileLinks.map((link) => (
                <NavigationLink
                  key={link.path}
                  {...link}
                  isActive={isActive(link.path)}
                  onClick={() => setIsOpen(false)}
                  className="p-4 rounded-lg"
                />
              ))}
            </div>
            
            <LogoutButton 
              onClick={() => setIsOpen(false)} 
              className="flex items-center p-4 rounded-lg mt-auto mb-4"
            />
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
